<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div class="col-md-6">
        <label for="name" class="form-control-label">
          Nombre<span class="required">*</span>
        </label>
        <input
          id="name"
          v-model="formModel.name"
          :class="[
                        'form-control',
                        v.name.$error ? 'is-invalid' : '',
                      ]"
          type="text"
          placeholder=""
        />
        <p v-if="v.name.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.name.$errors[0].$message }}
          </small>
        </p>
        <label for="description" class="form-control-label">
          Descripción
        </label>
        <textarea
            rows="10"
            id="description"
            v-model="formModel.description"
            :class="[
                        'form-control',
                        v.description.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="v.description.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.description.$errors[0].$message }}
          </small>
        </p>
        <label for="lang" class="form-control-label w-100">
          Idioma<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.lang"
            size="large"
            class="w-100"
        >
          <el-option
              v-for="selectItem in langs"
              :key="selectItem.id"
              :value="selectItem.value"
              :label="selectItem.name"
          />
        </el-select>
        <p v-if="v.lang.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.lang.$errors[0].$message }}
          </small>
        </p>
        <div class="row">
           <div class="col-md-6">
             <label for="latitude" class="form-control-label">
               Latitud<span class="required">*</span>
             </label>
             <input
                 id="latitude"
                 v-model="formModel.latitude"
                 :class="[
                        'form-control',
                        v.latitude.$error ? 'is-invalid' : '',
                      ]"
                 type="text"
                 placeholder=""
             />
             <p v-if="v.latitude.$error" class="invalid-feedback mb-0">
               <small>
                 {{ v.latitude.$errors[0].$message }}
               </small>
             </p>
           </div>
          <div class="col-md-6">
            <label for="longitude" class="form-control-label">
              Longitud<span class="required">*</span>
            </label>
            <input
                id="longitude"
                v-model="formModel.longitude"
                :class="[
                        'form-control',
                        v.longitude.$error ? 'is-invalid' : '',
                      ]"
                type="text"
                placeholder=""
            />
            <p v-if="v.longitude.$error" class="invalid-feedback mb-0">
              <small>
                {{ v.longitude.$errors[0].$message }}
              </small>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="trialType" class="form-control-label  w-100">
          Tipología de ruta<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.trailType"
            class="w-100"
            size="large"
        >
          <el-option
              v-for="selectItem in trailTypes"
              :key="selectItem.id"
              :value="selectItem.id"
              :label="selectItem.name"
          />
        </el-select>
        <p v-if="v.trailType.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.trailType.$errors[0].$message }}
          </small>
        </p>
        <label for="duration" class="form-control-label">
          Duración
        </label>
        <input
            type="text"
            id="duration"
            v-model="formModel.duration"
            :class="[
                        'form-control',
                        v.duration.$error ? 'is-invalid' : '',
                      ]"
            placeholder=""
        />
        <p v-if="v.duration.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.duration.$errors[0].$message }}
          </small>
        </p>
        <label for="type" class="form-control-label">
          Tipo de recorrido<span class="required">*</span>
        </label>
        <input
            type="text"
            id="type"
            v-model="formModel.type"
            :class="[
                        'form-control',
                        v.type.$error ? 'is-invalid' : '',
                      ]"
            placeholder=""
        />
        <p v-if="v.type.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.type.$errors[0].$message }}
          </small>
        </p>
        <label for="difficulty" class="form-control-label">
          Dificultad<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.difficulty"
            class="w-100"
            size="large"
        >
          <el-option
              v-for="selectItem in difficulties"
              :key="selectItem.id"
              :value="selectItem.name"
              :label="selectItem.name"

          />
        </el-select>
        <p v-if="v.difficulty.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.difficulty.$errors[0].$message }}
          </small>
        </p>
        <label for="video" class="form-control-label">
          Video<span class="required">*</span>
        </label>
        <!--<input
            v-model="formModel.videoUrl"
            type="text"
            id="video"
            :class="['form-control']"
            placeholder="Url de video"
        />-->
        <input
              type="file"
              id="video"
              @change="uploadVideo"
              :class="['form-control']"
              placeholder="Archivo de video"
          />
          <div class="img-thumbnail mt-3">
            <video class="w-100 p-2" muted autoplay v-if="previewUrl" :src="previewUrl"></video>
            <p v-if="v.videoUrl.$error" class="invalid-feedback mb-0">
              <small>
                {{ v.videoUrl.$errors[0].$message }}
              </small>
            </p>
        </div>
        <!--<p v-if="v.videoUrl.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.videoUrl.$errors[0].$message }}
          </small>
        </p>-->
        <label for="post_photo" class="form-control-label">
          Imagen de video<span class="required">*</span>
        </label>
        <el-upload
            class="upload-demo"
            drag
            :action="imagesUrl"
            :headers="headers"
            :on-success="videoImageUploaded"
            :on-remove="handleVideoImageRemove"
            v-model:file-list="videoImageFileList"
            list-type="picture"
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            Arrastre aquí <em>click para subir archivos</em>
          </div>
          <template #tip>
            <!-- <div class="el-upload__tip">
                jpg/png files with a size less than 500kb
              </div>-->
          </template>
        </el-upload>
        <p v-if="v.videoImage.$errors.length" class="invalid-feedback mb-0">
          <small>
            {{ v.videoImage.$errors[0].$message }}
          </small>
        </p>
      </div>
    </div>
      <div class="row mt-5">
        <div class="col-md-6">
          <label for="images" class="form-control-label">
            Imágenes<span class="required">*</span>
          </label>
          <el-upload
              class="upload-demo"
              multiple
              drag
              :headers="headers"
              :action="imagesUrl"
              :on-success="imageUploaded"
              :on-remove="handleRemove"
              v-model:file-list="imagesList"
              list-type="picture"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              Arrastre aquí <em>click para subir archivos</em>
            </div>
            <template #tip>
              <!-- <div class="el-upload__tip">
                 jpg/png files with a size less than 500kb
               </div>-->
            </template>
          </el-upload>
          <p v-if="v.images.$errors.length" class="invalid-feedback mb-0">
            <small>
              {{ v.images.$errors[0].$message }}
            </small>
          </p>
      </div>

        <div class="col-md-6">
          <label for="images360" class="form-control-label">
            Imágenes 360
          </label>
          <el-upload
              class="upload-demo"
              multiple
              drag
              :action="images360Url"
              :on-success="image360Uploaded"
              :on-remove="handle360Remove"
              v-model:file-list="images360List"
              list-type="picture"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              Arrastre aquí <em>click para subir archivos</em>
            </div>
            <template #tip>
              <!-- <div class="el-upload__tip">
                 jpg/png files with a size less than 500kb
               </div>-->
            </template>
          </el-upload>
          <p v-if="v.images360.$errors.length" class="invalid-feedback mb-0">
            <small>
              {{ v.images360.$errors[0].$message }}
            </small>
          </p>
        </div>
        <div class="col-md-6">
          <label for="file" class="form-control-label">
            Guiado<span class="required">*</span>
          </label>
          <input
              type="file"
              id="file"
              ref="file"
              @change="uploadGpx"
              :class="['form-control']"
              placeholder="Archivo .gpx"
          />
          <label v-if="formModel.filePath" class="form-control-label">
            Archivo de ruta:   <a target="_blank" :href="formModel.gpxUrl">{{formModel.filePath}}</a>
          </label>
          <p v-if="v.file.$errors.length" class="invalid-feedback mb-0">
            <small>
              {{ v.file.$errors[0].$message }}
            </small>
          </p>
        </div>
        <div class="col-md-6">
          <label for="tilesUrl" class="form-control-label">
            Url archivo de mapas (fichero comprimido)
          </label>
          <input
            id="tilesUrl"
            v-model="formModel.tilesUrl"
            :class="[
              'form-control',
              v.tilesUrl.$error ? 'is-invalid' : '',
            ]"
            type="text"
            placeholder=""
          />
        </div>
      </div>
    <div class="mt-3">
      <button
        type="submit"
        class="float-end btn btn-primary text-white bg-blue-600 rounded-lg border border-primary hover:bg-blue-900">
        {{ buttonText }}
      </button>
      <button
        class="me-2 float-end btn btn-primary text-danger bg-white border border-danger rounded-lg hover:bg-blue-900"
        @click="handleCancel"
      >
        Cancelar
      </button>
    </div>
  </form>
</template>

<script setup>
import {ref, defineProps, computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from 'sweetalert2';
import {difficultiesList} from "@/utils/difficulties";
import {languageList} from "@/utils/languages";
import {UploadFilled} from "@element-plus/icons-vue";
const store = useStore();
const router = useRouter();

const props = defineProps({
   entity: {
     type: Object,
     required: false
   },
  action: {
     type: String,
    required: true
  }
})
const formModel = ref(props.entity|| {});
const trailTypes = computed(() => store.state.trailType.trailTypes);
const imagesUrl = computed(() => process.env.VUE_APP_URL_API+'/trail_images');
const images360Url = computed(() => process.env.VUE_APP_URL_API+'/trail_image360s');
const imagesList = ref([]);
const imageIds = ref(null);
const images360List = ref([])
const image360Ids = ref(null);
const previewUrl = ref(formModel.value.videoUrl);
const videoFile = ref(null);
const gpxFile = ref(null);
const difficulties = difficultiesList()
const langs = languageList()
const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');
const videoImageFileList = ref([])
const videoImageId = ref(null);
const headers = computed(() => ({
  'Authorization': `Bearer ${store.state.auth?.user?.idToken || store.state.auth.idToken}`
}))
const getTrailTypes = async () => {
  return await store.dispatch("trailType/getTrailTypes");
};

onMounted(() => {
  getTrailTypes();
  if(props.entity.trailType){
    formModel.value.trailType = props.entity.trailType.id
  }
  if(props.entity.topics){
    let topics = []
    formModel.value.topics.map(item => {
        topics.push(item.id)
    })
    formModel.value.topics = topics
  }
  if(props.entity.images) {
    imageIds.value = []
    props.entity.images.map(item => {
      imageIds.value.push(item.id)
      imagesList.value.push({
        name: item.filePath,
        url: item.imageUrl,
        id: item.id
      })
      formModel.value.images = imageIds.value
    })
  }
    if(props.entity.images360){
      image360Ids.value = []
      props.entity.images360.map(item=>{
        image360Ids.value.push(item.id)
        images360List.value.push({
          name: item.filePath,
          url: item.imageUrl,
          id: item.id
        })
        formModel.value.images360 = image360Ids.value
      })
  }
  if(props.entity.videoImage){
    videoImageId.value =  props.entity.videoImage.id
    videoImageFileList.value.push({
      name: props.entity.videoImage.filePath,
      url: props.entity.videoImage.imageUrl
    })
    formModel.value.videoImage = props.entity.videoImage.id
  }
})
const imageUploaded = (response) => {
  if (response.id) {
    if(! imageIds.value){
      imageIds.value = []
    }
    imageIds.value.push(response.id);
    formModel.value.images = imageIds.value
  }
}
const image360Uploaded = (response) => {
  if (response.id) {
    if(!image360Ids.value){
      image360Ids.value = []
    }
    image360Ids.value.push(response.id);
    formModel.value.images360 = image360Ids.value
  }
}
const handleRemove = () => {
  imageIds.value = []
  imagesList.value.map(item => {
    imageIds.value.push(item.id)
  })
  formModel.value.images = imageIds.value
  if (imageIds.value.length === 0) {
    formModel.value.images = null
  }
}
  const handle360Remove = () => {
    image360Ids.value = []
    images360List.value.map(item=>{
      image360Ids.value.push(item.id)
    })
    formModel.value.images360 = image360Ids.value
    if(image360Ids.value.length === 0){
      formModel.value.images360 = null
    }

}
const rules = computed(() => {
  let rules =  {
    trailType: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    name: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    latitude: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    longitude: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    locality: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
    description: {
     // required: helpers.withMessage("Este campo es obligatorio", required)
    },
    difficulty: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    duration: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
    subtitle: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
    topics: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
    images: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    images360: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    },
    lang: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    file: {},
    videoUrl: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    videoImage: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    type: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    tilesUrl: {
      //required: helpers.withMessage("Este campo es obligatorio", required)
    }
  };
  if(props.action === 'create'){
    rules.images = {
      required: helpers.withMessage("Este campo es obligatorio", required),
    }
    rules.images360 =  {
      //required: helpers.withMessage("Este campo es obligatorio", required),
    }
    rules.file =  {
      required: helpers.withMessage("Este campo es obligatorio", required),
    }

  }

  return rules
});

const v$ = useVuelidate(rules, formModel);
const v = v$.value;

const handleSubmit = () => {
  v$.value.$validate();
  if (!v$.value.$invalid) {
    let payload;
    if (videoFile.value) {
      payload = new FormData();
      Object.entries(formModel.value).forEach(([key, value]) => {
        payload.append(key, value ?? '');
      });
      // Agregar el archivo
      payload.append('file', gpxFile.value);
      payload.append('videoFile', videoFile.value);
    } else {
      payload = {...formModel.value};
    }
    if(props.action === 'create'){
      createEntity(payload);
    }else{
      updateEntity(payload);
    }
  }
};

const handleCancel = () => {
  router.push({ name: "Senderos", params: {} });
};

const updateEntity = async (data) => {

  await store.dispatch("trail/edit", data).then(async (res) => {
    if (res.status && (res.status === 200 || res.status === 201)) {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Ruta editada satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      await router.push({name: "Senderos", params: {}});
    } else {
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: res.response.data.detail,
        showConfirmButton: false,
        timer: 3000
      });
    }

  });
}

const uploadGpx = (e) => {
  const files = e.target.files || e.dataTransfer.files;
  const reader = new FileReader();
  reader.readAsDataURL(files[0]);
  reader.onload = function(e) {
    formModel.value.file = e.target.result;
  };
  const file = files[0];
  if (file) {
    gpxFile.value = file;
  }

}

const uploadVideo = (e) => {
  const file = e.target.files[0];
  if (file) {
    videoFile.value = file;
    previewUrl.value = URL.createObjectURL(file);
    formModel.value.videoUrl = URL.createObjectURL(file);
  }
}

const createEntity = async (data) => {
    await store.dispatch("trail/add", data).then(async (res) => {
      if (res.status && (res.status === 200 || res.status === 201)) {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Ruta creada satisfactoriamente.',
          showConfirmButton: false,
          timer: 3000
        })
        await router.push({name: "Senderos", params: {}});
      } else {
        await Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: res.response.data.detail,
          showConfirmButton: false,
          timer: 3000
        })
      }
    })
}
const handleVideoImageRemove = () => {
  /*store.dispatch("natural/removeImage", imageId.value).then(()=> {
    imageId.value = null
  })*/
  videoImageId.value = null
  formModel.value.videoImage = null

}
const videoImageUploaded = (response) => {
  if(response.id){
    videoImageId.value = response.id;
    formModel.value.videoImage = videoImageId.value
  }
}
</script>
